import React from 'react'
import {NavLink}  from 'react-router-dom';
import slide1 from "./images/coffee2.jpg"
import slide2 from "./images/coffeebeans2.jpg"
import slide3 from "./images/coffee15.jpg"
import coffeetag from "./images/coffeebeans3.jpg"
import natural from "./images/coffeebeans1.jpg"

var tagStyle ={
  width:"50px",
   borderRadius:"50%"

}



var naturalStyle ={
  width:"40px",
  height:"40px",
   borderRadius:"50%"

}

export default function Home() {
  return (
    <div className='container'>
      <div className='welcomebox'>
         <h4>Coffee-Corner <span><img src={coffeetag} alt='coffeebeans' style={tagStyle}  /></span></h4>
         <br/>
        <p className="text ">
          Coffee-Corner provides the best <br/> coffee 
           you have ever drink. <br/> Tasty coffee and natural<br/>
           <span><img src={natural} alt='coffeebeans' style={naturalStyle}  /></span>
            coffee is our strength .
        </p> 
        <br/><br/>
        <NavLink exact to ="/coffee-shop"> <button className='btn btn-dark btncust'> Get Started</button></NavLink>
      </div>
       
       <div className='caroussel'>
             <span className='caroussel-items slider3'><img width="100%" height="100%" src={slide1} alt="coffee1"   /></span>
              <span className='caroussel-items slider3'><img width="100%" height="100%" src={slide2} alt="coffee2"  /></span>
             <span className='caroussel-items slider3'><img width="100%" height="100%" src={slide3} alt="coffee3"   /></span>
      
     </div> 
    </div>
  )
}
